<script>
export default {
  name: "v4-wx-open-launch-weapp",
  props: {
    info: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    path() {
      let path = this.info.path;
      if (decodeURIComponent(path) !== path) return decodeURIComponent(path);
      return path;
    }
  },
  methods: {
    onReady(e) {
      console.log("wx-open-launch-weapp ready", e);
    },
    onLaunch(e) {
      console.log("wx-open-launch-weapp launch", e);
    },
    onError(e) {
      console.log("wx-open-launch-weapp error", e);
    }
  }
};
</script>

<template>
  <div class="weapp" @click.stop>
    <wx-open-launch-weapp class="wx-open-launch-weapp"
                          appid="wxc520a2ff0e3ddaec"
                          :path="path"
                          @ready="onReady"
                          @launch="onLaunch"
                          @error="onError">
      <script type="text/wxtag-template">
        <style>
          .btn-wrapper {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            color: transparent;
          }
        </style>
        <div class="btn-wrapper">
          <div>{{ info.name }}</div>
        </div>
      </script>
    </wx-open-launch-weapp>
  </div>

</template>

<style scoped lang="scss">
.wx-open-launch-weapp {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.weapp {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/page/v2/components/v4/v4-wx-open-launch-weapp.vue